module.exports = __webpack_public_path__ + "img/new2.43dbe904.png";